import styled from 'styled-components'

const textPrimary = (p) => p.theme.colors.text.primaryText
const textSecondary = (p) => p.theme.colors.text.secondaryText
const borderColor = (p) => p.theme.colors.greys.defaultBorder || '#E0E0E0'
const errorColor = (p) => p.theme.colors.feedback.error || '#D32F2F'
const brandBlue = (p) => p.theme.colors.brand.blueOmint
const disabledGrey = (p) => p.theme.colors.greys.disabledGrey
const backgroundBlue = (p) => p.theme.colors.brand.backgroundBlue
const dividerGray = (p) => p.theme.colors.greys.dividerGray

export const SelectContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  position: relative;
  align-items:strech;
`

export const SelectLabel = styled.label`
  display:flex;
  font-size: 16px;
  font-weight: 500;
  color: ${textPrimary};
`

export const SelectButton = styled.button`
  width: 100%;
  padding: ${props => props.padding || '12px 16px 12px 16px'};
  font-size: 16px;
  color: ${props => props.$hasValue ? textPrimary : disabledGrey};
  background-color: white;
  border: 1px solid ${props => props.$error ? errorColor : props.$isOpen ? brandBlue : borderColor};
  border-radius: 8px;
  text-align: left;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;

  &:hover {
    border-color: ${props => props.$error ? errorColor : brandBlue};
  }

  &:focus {
    outline: none;
    border-color: ${props => props.$error ? errorColor : brandBlue};
  }

  &:disabled {
    background-color: #F5F5F5;
    cursor: not-allowed;
    opacity: 0.6;
  }
`

export const SelectIcon = styled.div`
  pointer-events: none;
  display: flex;
  align-items: center;
  color: ${textSecondary};
  transition: transform 0.2s ease;
  svg {
    width: 12px;
    height: 12px;
  }
`

export const DropdownList = styled.ul`
  position: absolute;
  top: 48px;
  left: 0;
  right: 0;
  background-color: white;
  border: 1px solid ${borderColor};
  border-top: none;
  border-radius: 0 0 8px 8px;
  border-color: ${brandBlue};
  max-height: 240px;
  overflow-y: auto;
  z-index: 1000;
  margin: 0;
  padding: 2px 0;
  list-style: none;
`

export const DropdownOption = styled.li`
  padding: 12px 16px;
  font-size: 16px;
  color: ${textPrimary};
  cursor: pointer;
  transition: background-color 0.15s ease;
  background-color: ${props => props.$isSelected ? backgroundBlue : 'transparent'};
  position: relative;

  &:not(:last-child)::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 5%;
    right: 5%;
    height: 1px;
    background-color: ${dividerGray};
  }

  &:hover {
    background-color: ${backgroundBlue};
  }

  &:active {
    background-color: #E0E0E0;
  }
`

export const ErrorMessage = styled.span`
  font-size: 14px;
  color: ${errorColor};
`

export const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
`

export const StyledCheckbox = styled.div`
  width: 18px;
  height: 18px;
  border: 2px solid ${props => props.$checked ? brandBlue : borderColor};
  border-radius: 4px;
  background-color: ${props => props.$checked ? brandBlue : 'white'};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  flex-shrink: 0;

  &:hover {
    border-color: ${brandBlue};
  }

  svg {
    width: 12px;
    height: 12px;
    fill: white;
    opacity: ${props => props.$checked ? 1 : 0};
    transition: opacity 0.15s ease;
  }
`
